export const formatReasonCode = (reasonCode) => {
  const value = String(reasonCode ?? "")
    .replace(/_/g, " ")
    .trim()

  if (!value) return ""

  return value.charAt(0).toUpperCase() + value.slice(1)
}
